import { Link } from "@tanstack/react-router";
import { Button } from "@ndd/ui";
import type { ReadSourceRef } from "../../../../shared/chat-sources";

export function AskAboutSourceAction({
  rdSlug,
  source,
}: {
  rdSlug: string;
  source: ReadSourceRef;
}) {
  return (
    <Button
      asChild
      variant="outline"
      size="xs"
      className="border-ai bg-ai-soft text-ai shadow-none hover:bg-ai-soft/70 hover:text-ai"
    >
      <Link
        to="/rds/$rdId/chats/new"
        params={{ rdId: rdSlug }}
        search={{ sourceType: source.type, sourceId: source.id }}
      >
        Ask about this
      </Link>
    </Button>
  );
}
